import dashboardServices from "../services/hoa-dashboard-api-service";
import { decodeNestedURI } from "./decode-url";

const getNewUrl = async (url: string, path: string, folder?: string) => {
    let extractUrl = url.split('?')[0];
    let extractUrlArray = extractUrl.split('/');
    let fileName = decodeNestedURI(extractUrlArray[extractUrlArray.length-1]);
    let folderName = decodeNestedURI(extractUrlArray[extractUrlArray.length-2]);
    let s3_path = `${path}/${extractUrlArray[4]}/${folder ? folder : folderName}/${fileName}`
    const signedUrl = await dashboardServices.getSignedUrl(s3_path)
    return signedUrl.data;
}

export const GenerateNewDocumentUrl = {
    getNewUrl,
}